import classes from "./FilterCategoryButton.module.scss";

const FilterCategoryButton = ({ name, value, text, isChecked, onChanged }) => {
  let id = value.replace(/ /g, "");

  return (
    <div className={classes.FilterCategoryButton}>
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={isChecked}
        onChange={() => onChanged(value)}
      />
      <label htmlFor={id}>{text}</label>
    </div>
  );
};

export default FilterCategoryButton;
